console.clear();
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var d3 = {
  ...require("d3-axis"),
  ...require("d3-scale"),
  ...require("d3-selection"),
  ...require("d3-array"),
  ...require("d3-format"),
  ...require("d3-geo"),
  ...require("d3-transition")
};

// var d3 = require("d3/dist/d3.min");


var noUiSlider = require("./lib/nouislider.min.js");

var onWindowLoaded = function() {


  var affectedData = window.DATA;
  var formatComma = d3.format(",");

  function formatRound(val) {
    return formatComma(Math.round(val/1000)*1000);

  }

  //make buildings key
  var keyStructureContainer = d3.select("div.keyWrapper .structure");
  var breaksStructure = window.STRUCTUREBREAKS;

  var keyStructureBlocks = keyStructureContainer.selectAll(".breaks")
                .data(breaksStructure)
                .enter()
                .append("div")
                .attr("class", "key-block structure");

  keyStructureBlocks.append("div")
              .attr("class", "key-break structure")
              .style("background-color", d=> `rgb${d.color}`);

  keyStructureBlocks.append("h3")
              .text(d=>d.age);

  var keySurgeContainer = d3.select("div.keyWrapper .surge");
  var breaks = window.BREAKS;

  var keySurgeBlocks = keySurgeContainer.selectAll(".breaks")
                .data(breaks)
                .enter()
                .append("div")
                .attr("class", "key-block surge");

  keySurgeBlocks.append("div")
              .attr("class", "key-break surge")
              .style("background-color", d=> `rgb${d.color}`);

  keySurgeBlocks.append("h3")
              .text(d=>d.depth);


  var structureText = d3.select("div.structureText").style("opacity", 1);
  var surgeText = d3.select("div.surgeText").style("opacity", 0.25);

  //add images
  var surgeContainer = d3.select("div.animation div.surge");

  var years = d3.range(2020,2110,30);
  var first = years[0];

  //set year to first
  var yearElement = d3.select("span.year");
  yearElement.html(first);


  var surgeFrames = surgeContainer.selectAll(".frame")
            .data(years)
            .enter()
            .append("img")
            .attr("class", d=> d)
            .classed("visible", false)
            .attr("src", d=>`surge/miami_Int_${d}.png`);

  var structureContainer = d3.select("div.animation div.structure");

  var structureYears = [1990,2000,2010];
  var firstStructure = structureYears[0];

  //set structure year to first
  var yearStructureElement = d3.select("span.yearStructure");
  yearStructureElement.html(firstStructure+"s");

  var structureFrames = structureContainer.selectAll(".frame")
            .data(structureYears)
            .enter()
            .append("img")
            .attr("class", d=> d)
            .classed("visible", d => (d == firstStructure))
            .attr("src", d=>`structures/${d}.jpg`);
  

  // make slider
  var slider = document.getElementById('slider');

  noUiSlider.create(slider, {
      start: [2020],
      step: 30,
      range: {
          'min': 2020,
          'max': 2080
      }
  });

  //make structure slider
  var structureSlider = document.getElementById('structureSlider');

  noUiSlider.create(structureSlider, {
      start: [firstStructure],
      step: 10,
      range: {
          'min': 1990,
          'max': 2010
      }
  });

  var userInteracted = false; //check whether user has interacted
  var hasStarted = false;

  //event handling
  slider.noUiSlider.on("update", function(){
    var val = slider.noUiSlider.get(true);
    var current = Number(yearElement.html());
    // if(val != current) {
      yearElement.html(val);
      surgeFrames.classed("visible", d => (d == val));
    // }

  })

  structureSlider.noUiSlider.on("update", function(){
    var val = structureSlider.noUiSlider.get(true);
    var current = Number(yearStructureElement.html());
    if(val != current) {
      yearStructureElement.html(val+"s");
      structureFrames.classed("visible", d => (d == val));
      surgeFrames.classed("visible", false);
    }

  })

  slider.noUiSlider.on("slide", function(){
      userInteracted = true;
      surgeText.style("opacity", 1);
      // surgeKeyWrapper.style("opacity", 1);
      // structureText.style("opacity", 0.25);
  })

  structureSlider.noUiSlider.on("slide", function(){
      userInteracted = true;
      surgeText.style("opacity", 0.25);
      // surgeKeyWrapper.style("opacity", 0.25);
      structureText.style("opacity", 1);
  })

  //above fires once on creation, so reset userInteracted to false
  userInteracted = false;

  //set up multi-part animation
  var overallLength = structureYears.length + years.length;

  //two modes
  var structureMode = true; //start with structure;
  var surgeMode = false;


  function animateFrames(i){

    //if slider is used stop animation
    if(userInteracted) return;

    //check which mode we're in
    if(i<structureYears.length){
      structureSlider.noUiSlider.set(structureYears[i]);
      surgeText.transition(500).style("opacity", 0.25);
      // surgeKeyWrapper.transition(500).style("opacity", 0.25);
      // structureText.style("opacity", 1);

    } else {
      var j = i - structureYears.length;
      slider.noUiSlider.set(years[j]);
      surgeText.transition(500).style("opacity", 1);
      // surgeKeyWrapper.transition(500).style("opacity", 1);
      // structureText.style("opacity", 0.25);
    }

    //get ref to next frame
    var nextFrame;
    if(i+1 == overallLength) {
      nextFrame = 0;
    } else {
      nextFrame = i + 1;
    }

    setTimeout(function(){
      animateFrames(nextFrame);
    },1500);

  }


  //start looping through frames once graphic is visible
  var observer = new IntersectionObserver(intersectionCallback, {threshold: 0.25});
  var target = document.querySelector(".target");
  observer.observe(target);
  
  function intersectionCallback(entries, observer){
    entries.forEach(entry=> {
      if(entry.isIntersecting){
        //only start animation once
        if(hasStarted) return;
        animateFrames(0);
        hasStarted = true;
      }
    })
  }

  function sizeHeaders(){
    var labelHeds = d3.selectAll('.header');
    labelHeds.style("height", null);
    var labelMaxHeight = 0;

    labelHeds.each(function(d,i) {
        var thisHeight = this.getBoundingClientRect().height;
        if (thisHeight > labelMaxHeight) {
            labelMaxHeight = thisHeight;
        }
    });
    labelHeds.style('height', labelMaxHeight + 'px');
  }

  // sizeHeaders();
  pym.then(child => {
      child.sendHeight();

      // child.onMessage("on-screen", function(bucket) {
      //     ANALYTICS.trackEvent("on-screen", bucket);
      // });
      // child.onMessage("scroll-depth", function(data) {
      //     data = JSON.parse(data);
      //     ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
      // });
      
      window.addEventListener("resize", function(){
        sizeHeaders();

        child.sendHeight();

      });
  });
}



// wait for images to load
window.onload = onWindowLoaded;
